/**
 * Created by neo on 26.02.17.
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { translate } from 'react-i18next';
import Flight from './Flight';
import FlightOffer from './FlightOffer';
import Transfers from './Transfers';
import Location from '../Store/Location';
import Config from '../Config';
import {
  Container, Row, Col,
  Collapse,
  FormGroup,
  Input,
  Label,
  Card, CardBody,
} from 'reactstrap';
import Settings from '../Store/Settings';
import { Link } from 'react-router';
import BackendFactory from '../Services/BackendFactory';
import moment from 'moment-timezone';
import TestComponent from './Flight';

@observer
export class Screen extends Component {
  @observable loading: boolean = true;

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      selectedLocations: [],
      singleSeatsData: [],
    };
  }

  toggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  locationChanged(id) {
    var selectedLocations = this.state.selectedLocations.slice(0);
    var index = selectedLocations.indexOf(id);
    if (index >= 0) {
      selectedLocations.splice(index, 1);
    } else {
      selectedLocations.push(id);
    }

    this.setState({
      selectedLocations: selectedLocations,
    });
  }

  componentDidMount() {
    this.loadLocations();
  }

  async loadLocations() {

    try {
      let locations = await Location.listAll();
      console.log(locations);
      //store all available locations
      this.locations = locations;
      //select all locations by default
      if (this.locations) {
        this.setState({
          selectedLocations: this.locations.map(l => l.id),
        });
      }
    } finally {
      this.loading = false;
    }
  }

  isLocationSelected(id) {
    if (this.state.selectedLocations.indexOf(id) >= 0) {
      return true;
    }
    return false;
  }

  render() {
    const { t } = this.props;
    const { settings } = Settings;
    if (this.loading) {
      return (
        <div className='loading-container'>
          <div className='loading-text'>{t('Die Buchungsplattform wird geladen')}</div>
        </div>
      );
    }
    return (
      <div>
        <Row className='dashboard'>
          <Col>
            {
              settings.get('has_transfer_flights') &&
              <Row className='pb-5'>
                <Col>
                  <Container>
                    <Transfers locations={this.state.selectedLocations} />
                  </Container>
                </Col>
              </Row>
            }
            {
              this.locations.length > 1 &&
              <Row className={!settings.get('has_transfer_flights') ? 'pt-5 pb-5' : 'pb-5'}>
                <Col>
                  <Container>
                    <Card className='filter-card'>
                      <div className='card-header' onClick={this.toggle} style={{ cursor: 'pointer' }}>
                        {t('Filter by location')}
                      </div>
                      <Collapse isOpen={this.state.isOpen}>
                        <CardBody>
                          <Row>
                            {
                              this.locations && this.locations.map((l, i) => (
                                <Col md='4' key={'location' + i}>
                                  <FormGroup check>
                                    <Label check>
                                      <Input
                                        checked={this.isLocationSelected(l.id)}
                                        onChange={() => this.locationChanged(l.id)}
                                        type='checkbox'
                                      />{' '}
                                      {l.name}
                                    </Label>
                                  </FormGroup>
                                </Col>
                              ))
                            }
                          </Row>
                        </CardBody>
                      </Collapse>
                    </Card>
                  </Container>
                </Col>
              </Row>
            }
            <Row>
              <Col>
                <Container className='separator'>
                  <FlightOffer locations={this.state.selectedLocations} />
                </Container>
              </Col>
            </Row>
            <Row>
              <Col>
                <Container>
                  <Flight locations={this.state.selectedLocations} />
                </Container>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

export default translate()(Screen);



// WEBPACK FOOTER //
// ./src/App/Dashboard/Screen.js